"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;
var React = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
require("../../../src/ui/tags/tags.module.scss");
var _ui = require("../../ui");
var _excluded = ["children", "className", "iconTooltip", "onClear", "onClick"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
var Tag = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    iconTooltip = props.iconTooltip,
    onClear = props.onClear,
    onClick = props.onClick,
    attributesOriginal = _objectWithoutProperties(props, _excluded),
    attributes = attributesOriginal,
    clickable = typeof onClick === 'function',
    clearable = typeof onClear === 'function';
  className = (0, _utils.ClassNames)('kui-tag', clickable ? 'kui-tag--clickable' : null, clearable ? 'kui-tag--clearable' : null, className);
  if (clickable) {
    attributes.onClick = function (event) {
      var classes = (0, _utils.getParentsClasses)(event.target, ['kui-tag__clear', 'kui-tag']);
      if (classes.includes('kui-tag__clear')) {
        if (clearable) onClear(event);
        return;
      }
      onClick(event);
    };
  }
  var getButtonClear = function getButtonClear() {
    var tooltip = typeof iconTooltip === 'string' ? {
      value: iconTooltip
    } : iconTooltip;
    return /*#__PURE__*/React.createElement(_ui.Button, {
      className: 'kui-tag__clear',
      variant: 'icon',
      tooltip: tooltip,
      "aria-label": tooltip.value
    }, /*#__PURE__*/React.createElement(_ui.Icon, {
      xlink: 'clear',
      size: 24
    }));
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    className: className,
    ref: ref,
    tabIndex: 0
  }, attributes), /*#__PURE__*/React.createElement("span", {
    className: 'kui-tag__text'
  }, children), clearable && getButtonClear());
});
exports.Tag = Tag;
Tag.defaultProps = {
  onClear: null,
  onClick: null,
  iconTooltip: 'Remove'
};
Tag.displayName = 'Tag';